import { useTranslation } from 'react-i18next';
import { ErrorSection } from '@/common/components';
import styles from './styles.module.scss';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  return <ErrorSection className={styles.wrapper} extra={t('errorSection.invalidUrl')} />;
};
